import React, { Component } from 'react'
import { reaction } from 'mobx'
import { observer, inject } from 'mobx-react'

import GoodsItem from './GoodsItem'

import config from '../config'
import api from '../services'
import utils from '../utils'
const { FE } = utils,{ pvIds } = config

class SubList extends Component {
  constructor(props){
    super(props)
    this.state = {
      hasMore: true
    }
    this.getMinPrice = this.getMinPrice.bind(this)
    this.show = this.show.bind(this)
  }

  show(){
    // 统计
    window.trackCustomEvent('auto_common_event',{
      'biz':'ec',
      'scene':0,
      'type':'click',
      'action':'mall_m_redpacket_recommend_more_click',
      'ctime':new Date().getTime(),
      'area':0,
      'element':0,
      'pmark':0,
      'target':0,
      'ctype':0,
      'cid':0
    },{
      'ek1':0,
      'ek2':0
    })
    this.setState({hasMore: false})
  }

  getMinPrice(itemId){
    let list = this.props.minPriceList
    return list.length ?
              list.filter(item => item.item.itemId === itemId)[0] ?
                list.filter(item => item.item.itemId === itemId)[0].minPrice
                  :
                  0
              :
              0
  }

  componentWillMount(){
    this.setState({hasMore: this.props.list.length>2})
  }
  
  render(){
    let { list, city, cityName } = this.props,{ hasMore } = this.state
    return(
      <div>
        {
          list.map((item,index) => <div key={item.itemId} className={hasMore&&index>1?'fn-hide':''}>
            <GoodsItem goods={item}
                        pvId={pvIds.pick}
                        minPrice={this.getMinPrice(item.itemId)}
                        cityName={cityName}
                        city={city} />
          </div>)
        }
        <p className={hasMore?'showMore':'showMore fn-hide'} onClick={this.show}>查看更多<i className='showMore__icon'></i></p>
      </div>
    )
  }
}

@inject('cityInfo')
@inject('carInfo')
@observer
export default class HotFloor extends Component {
  constructor(props){
    super(props)
    this.state = {
      list: [],
      data: [],
      navList: [],
      minPriceList: []
    }

    this.loadData = this.loadData.bind(this)
    this.getPrice = this.getPrice.bind(this)

    reaction(
      () => this.props.cityInfo.info.cityId,
      cityId => {
        if(FE.User.isLogin()) this.loadData()
      }
    )
  }

  loadData(){
    let { cityInfo } = this.props,
    cityId = cityInfo.info.cityId,
    sessionId = FE.Utils.readCookie('sessionid').split('||')[0]

    api.getRedPacketGoods(cityId,sessionId)
    .then(data => {
      if(data.returncode === 0 && data.result && data.result.length) {
        let navList = [],totalList = []
        data.result.map(ele => {
          navList.push({
            isNav: true,
            brandId: ele.brandId,
            brandName: ele.brandName,
            seriesId: ele.seriesId,
            seriesName: ele.seriesName
          })
          if(ele.redPacketGoods) {
            totalList = totalList.concat(ele.redPacketGoods)
          }else if(ele.commonGoods) {
            totalList = totalList.concat(ele.commonGoods)
          }
          if(ele.promotionGoods) {
            totalList = totalList.concat(ele.promotionGoods)
          }
        })

        // 统计
        window.trackCustomEvent('auto_common_event',{
          'biz':'ec',
          'scene':0,
          'type':'show',
          'action':'mall_m_redpacket_recommend_show',
          'ctime':new Date().getTime(),
          'area':0,
          'element':0,
          'pmark':0,
          'target':0,
          'ctype':0,
          'cid':0
        },{
          'ek1':0,
          'ek2':0
        })

        this.setState({
          navList,
          data: data.result,
          list: totalList
        },this.getPrice)
        
        this.props.carInfo.setPrefer(navList[0])
        this.props.carInfo.hotHandler(false)
      }else {
        this.props.carInfo.hotHandler(true)
      }
    })
    .catch(() => {})
  }

  getPrice(){
    let { cityInfo } = this.props

    api.getPriceForList({
      city: cityInfo.info.cityId,
      itemIds: this.state.list.map(item => item.itemId).join(',')
    }).then(data => {
      if(data.returncode === 0){
        this.setState({
          minPriceList: data.result
        })
      }
    }).catch(()=>{})
  }

  componentDidMount(){
    this.loadData()
  }
  
  render(){
    let { navList, data, minPriceList } = this.state,
    total = data.map(ele => {
      let list = []
      if(ele.redPacketGoods) {
        list = list.concat(ele.redPacketGoods)
      }else if(ele.commonGoods) {
        list = list.concat(ele.commonGoods)
      }
      if(ele.promotionGoods) {
        list = list.concat(ele.promotionGoods)
      }

      return <div key={ele.seriesId}>
        <div key={Math.random()}
            className='title--sub' 
            id={`target${ele.seriesId}`}>
          <span>{ele.seriesName}</span>
        </div>
        <SubList list={list}
                minPriceList={minPriceList}
                city={this.props.cityInfo.info.cityId}
                cityName={this.props.cityInfo.info.cityName} />
      </div>
    }),
    navs = navList.map(nav => <a key={Math.random()} 
                                  href={`#target${nav.seriesId}`}
                                  className='prefer-car'>
                                  {nav.seriesName}
                                </a>)

    return(
      <div className={navs.length?'':'fn-hide'}>
        <div className='title'>
          <span>为你精选</span>
        </div>
        <div className='preferNav'>
          { navs }
        </div>
        { total }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/PickFloor.js